var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"cv-side-nav bx--side-nav bx--side-nav__navigation",class:{
    'bx--side-nav--expanded': _vm.panelExpanded,
    'bx--side-nav--rail': _vm.rail,
    'bx--side-nav--collapsed': !_vm.panelExpanded && _vm.fixed,
    'bx--side-nav--ux': _vm.isChildOfHeader,
  },attrs:{"aria-hidden":!_vm.panelExpanded && !_vm.fixed,"id":_vm.id},on:{"focusout":_vm.onFocusout,"mousedown":_vm.onMouseDown}},[_vm._t("default"),(!_vm.fixed && !_vm.rail && !_vm.headerEmbedded)?_c('cv-side-nav-footer',{attrs:{"expanded":_vm.panelExpanded,"assistiveText":_vm.assistiveToggleText},on:{"toggle-expand":_vm.toggleExpand}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }